export default __webpack_public_path__ + "static/media/bent-felirat.ec4e552c.png";